<div class="modal-header" style="border-bottom: 2px solid #00d398; padding: 1rem 1.5rem;">
  <div>
    <h4 class="modal-title" style="font-family: 'Rubik', serif; font-weight: 600; margin-bottom: 2px;">
      Asientos (Solo Visualización)
    </h4>
    <p style="margin-bottom: 0; font-size: 14px; color: #666;">
      {{ routeOrigin }} a {{ routeDestination }}
    </p>
    <p style="margin-bottom: 0; font-size: 13px; color: #666; text-transform: capitalize;">
      {{ routeDateLabel }}
    </p>
  </div>
  <button type="button" class="btn-close close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>

<div class="modal-body" style="padding: 1.5rem; max-height: 75vh; overflow-y: auto;">

  <div *ngIf="loading" class="text-center" style="padding: 2rem 0; color: #666;">
    Buscando el mapa de asientos...
  </div>

  <div *ngIf="!loading && loadError" class="text-center" style="padding: 1.5rem; background-color: #fff3e0; border-radius: 8px;">
    <p style="margin-bottom: 0; font-size: 14px;">No pudimos obtener el mapa de asientos para este vuelo.</p>
  </div>

  <ng-container *ngIf="!loading && !loadError">

    <p style="margin-bottom: 1rem; font-size: 14px; color: #333;">
      Tiempo de Viaje: <strong>{{ routeDurationLabel }}</strong>
      <span *ngIf="activeOfferSegment"> &nbsp;·&nbsp; {{ activeOfferSegment.airline?.code }}{{ activeOfferSegment.flight?.number }} - {{ activeOfferSegment.flight?.equipment }}</span>
    </p>

    <!-- Selector de tramo (sólo si el vuelo tiene escalas) -->
    <div *ngIf="segments.length > 1" class="d-flex" style="gap: 8px; margin-bottom: 1rem; flex-wrap: wrap;">
      <button
        *ngFor="let segment of segments; let i = index"
        type="button"
        (click)="selectSegment(i)"
        [style.background-color]="activeSegmentIndex === i ? '#00d398' : '#f1f1f1'"
        [style.color]="activeSegmentIndex === i ? '#ffffff' : '#333333'"
        style="border: none; border-radius: 50rem; padding: 0.35rem 1rem; font-family: 'Rubik'; font-size: 13px; font-weight: 600;"
      >
        {{ segment.label }}
      </button>
    </div>

    <!-- Referencias -->
    <div class="d-flex flex-wrap align-items-center" style="gap: 16px; margin-bottom: 1.5rem; padding: 10px 14px; background-color: #f8f9fa; border-radius: 8px;">
      <div class="d-flex align-items-center" style="gap: 6px;">
        <span class="seat-swatch seat-extra"></span>
        <span style="font-size: 12px; color: #333;">Main Cabin Extra ($)</span>
      </div>
      <div class="d-flex align-items-center" style="gap: 6px;">
        <span class="seat-swatch seat-preferred"></span>
        <span style="font-size: 12px; color: #333;">Preferred ($)</span>
      </div>
      <div class="d-flex align-items-center" style="gap: 6px;">
        <span class="seat-swatch seat-available"></span>
        <span style="font-size: 12px; color: #333;">Disponible</span>
      </div>
      <div class="d-flex align-items-center" style="gap: 6px;">
        <span class="seat-swatch seat-unavailable"></span>
        <span style="font-size: 12px; color: #333;">No Disponible</span>
      </div>
      <div class="d-flex align-items-center" style="gap: 6px;">
        <span class="seat-swatch seat-rear-facing"></span>
        <span style="font-size: 12px; color: #333;">Mira Hacia Atrás</span>
      </div>
    </div>

    <div *ngIf="!activeSegment || activeSegment.cabins.length === 0" class="text-center" style="padding: 1.5rem; color: #666;">
      No hay información de asientos para este tramo.
    </div>

    <!-- Cabinas -->
    <div *ngFor="let cabin of activeSegment?.cabins; let cabinIndex = index" class="seat-cabin" style="margin-bottom: 2rem;">
      <h5 style="text-align: center; font-weight: 600; margin-bottom: 1rem;">{{ getCabinTitle(cabin, cabinIndex) }}</h5>

      <div class="seat-fuselage">
        <div class="seat-fuselage-bar seat-fuselage-bar-left"></div>

        <div class="seat-fuselage-content">
          <ng-container *ngFor="let rowType of cabin.rowTypes">

            <!-- Encabezado de columnas -->
            <div class="seat-row seat-row-header">
              <ng-container *ngFor="let group of getColumnGroups(rowType); let lastGroup = last">
                <div class="seat-group">
                  <span *ngFor="let column of group" class="seat-cell seat-label">{{ column }}</span>
                </div>
              </ng-container>
            </div>

            <!-- Filas -->
            <div *ngFor="let row of getRowsForRange(cabin, rowType)" class="seat-row">
              <ng-container *ngFor="let group of getColumnGroups(rowType); let groupIndex = index">
                <div class="seat-group">
                  <ng-container *ngFor="let column of group; let colIndex = index">
                    <span
                      *ngIf="groupIndex === 0 && colIndex === 0"
                      class="seat-cell seat-row-number"
                    >{{ row.rowNumber }}</span>

                    <span
                      class="seat-cell seat-box"
                      [ngClass]="getSeatStatusClass(getSeatForColumn(row, column))"
                      [title]="getSeatForColumn(row, column)?.seat"
                    >
                      <i *ngIf="isUnavailable(getSeatForColumn(row, column))" class="bi bi-x-lg"></i>
                      <i *ngIf="isRearFacing(getSeatForColumn(row, column))" class="bi bi-chevron-down"></i>
                    </span>
                  </ng-container>
                </div>
              </ng-container>
              <span class="seat-cell seat-row-number">{{ row.rowNumber }}</span>
            </div>

          </ng-container>
        </div>

        <div class="seat-fuselage-bar seat-fuselage-bar-right"></div>
      </div>
    </div>

  </ng-container>
</div>
